<div class="page">
  <div class="loader" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <div class="header-page">
    <div class="title">
      Utilisateurs
    </div>
    <div class="add-user">
      <div (click)="onAddUser()">
        Ajouter un utilisateur
      </div>
    </div>
  </div>
  <div class="new-user" *ngIf="newUserTriggered">
    <div class="sur-head">
      <div class="close" (click)="closeNewUser()">
        <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/>
        </svg>
      </div>
    </div>
    <form #registerForm="ngForm" (ngSubmit)='onRegister(registerForm)'>
      <div class="form-group Input">
        <label for="firstname" class="Input-label">Prénom</label>
        <input
          type="firstname"
          id="firstname"
          class="form-control Input-text"
          ngModel
          name="firstname"
          required
          placeholder="Prénom"
          />
      </div>
      <div class="form-group Input">
        <label for="named" class="Input-label">Nom</label>
        <input
          type="named"
          id="named"
          class="form-control Input-text"
          ngModel
          name="name"
          required
          placeholder="Nom"
          />
      </div>
      <div class="form-group Input">
        <label for="email" class="Input-label">Email</label>
        <input
          type="email"
          id="email"
          class="form-control Input-email"
          ngModel
          email
          name="email"
          required
          placeholder="Email"
          />
      </div>
      <div class="form-group Input">
        <label for="password" class="Input-label">Mot de passe</label>
        <input
          type="password"
          id="password"
          class="form-control Input-text"
          ngModel
          name="password"
          required
          placeholder="Mot de passe"
          />
      </div>
      <div class="form-validate">
        <button
          class="btn btn-primary"
          type="submit"
          disabled
          [disabled]="!registerForm.valid"
          >
          Ajouter un utilisateur
        </button>
      </div>
    </form>
  </div>
  <div class="all-users">
    <div class="user" *ngFor="let user of users">
      <div class="content">
        <div class="names">
          <span class="name">
            {{ user.name }}
          </span>
          <span class="firstname">
            {{ user.firstname }}
          </span>
        </div>
        <div class="mail">
          {{ user.email }}
        </div>
      </div>
      <div class="delete" (click)="onDelete(user)">
        <svg height="427pt" viewBox="-40 0 427 427.00131" width="427pt" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg>
      </div>
    </div>
  </div>
</div>
